import { render } from "./UniversalLayout.vue?vue&type=template&id=7d0b30ca"
import script from "./UniversalLayout.vue?vue&type=script&lang=js"
export * from "./UniversalLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__